import React from 'react';
import PropTypes from 'prop-types';
import { buildAddressArray } from 'platform/utilities/facilities-and-mapbox';

function LocationDirectionsLink({ location }) {
  const addressArray = buildAddressArray(location);

  let address;
  if (addressArray.length !== 0) {
    // For the directions URL, only use street (first line) and city/state/zip
    // (last line). address2/address3 (suite, building, etc.) can confuse
    // Google Maps routing.
    const urlAddressArray =
      addressArray.length > 2
        ? [addressArray[0], addressArray[addressArray.length - 1]]
        : addressArray;
    address = urlAddressArray.join(', ');
  } else {
    // If we don't have an address fallback on coords
    const { lat, long } = location.attributes;
    address = `${lat},${long}`;
  }

  return (
    <p>
      <va-link
        href={`https://maps.google.com?saddr=Current+Location&daddr=${encodeURIComponent(
          address,
        )}`}
        text="Get directions on Google Maps"
        label={`Get directions on Google Maps to ${location.attributes.name}`}
      />
    </p>
  );
}

LocationDirectionsLink.propTypes = {
  location: PropTypes.object,
  query: PropTypes.object,
};

export default LocationDirectionsLink;
